module.exports = __webpack_public_path__ + "image/footer-ewm2.png";